import styled from 'styled-components';
import background from '../../images/pdficon.png';

export const SectionPdf = styled.div`
  padding: 50px 0 20px;

  h2 {
    text-align: center;
    color: #4a4a4a;
    @media (max-width: 767.98px) {
      font-size: 20px;
      line-height: 30px;
    }
  }

  @media (max-width: 767.98px) {
    padding: 30px 0 0;
  }
`;

export const RCard = styled.div`
  margin: 1rem 0;
  position: relative;

  &:nth-child(even) {
    background: #f7f7f7;
  }

  @media (max-width: 767.98px) {
    &:nth-child(even) {
      background: 0 0;
    }
  }
`;

export const PdfCard = styled.a`
  border: 1px solid #ebebeb;
  display: flex;
  padding: 42px 0;
  width: 100%;
  color: #000;
  text-decoration: none;

  &:hover {
    background: #ebebeb;
  }

  @media (max-width: 575.98px) {
    padding: 30px 0 15px;
    flex-flow: column;
  }
`;

export const PdfPart = styled.div`
  width: 25%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  text-align: center;
  border-right: ${({ dir }) => (dir === 'rtl' ? '' : '1px solid #ebebeb')};
  border-left: ${({ dir }) => (dir === 'rtl' ? '1px solid #ebebeb' : '')};
  padding: 0 50px;
  font-size: 12px;
  letter-spacing: 1.29px;
  line-height: 16px;
  text-transform: uppercase;
  color: #000;
  align-items: center;
  &.free_zonecta {
    .has-phone {
      text-decoration: none !important;
    }
  }

  &.no-underline {
    span {
      text-decoration: none;
    }
  }

  @media (max-width: 575.98px) {
    width: 100%;
    border-right: none;
    padding-bottom: 1rem;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      width: 50%;
      height: 1px;
      margin: 0 auto;
      display: block;
      background: #ebebeb;
    }
  }

  .pdficon {
    margin: 0 auto 1.5rem;
    vertical-align: middle;
    display: inline-flex;
    width: 54px;
    height: 36px;
    background: url(${background}) no-repeat center;
    background-size: contain;
  }
  .has-phone {
    text-decoration: underline;
  }
`;

export const PdfDetails = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  color: #000;
  padding: 0 80px 0 50px;
  width: 75%;

  @media (max-width: 575.98px) {
    text-align: center;
    width: 100%;
    padding: 1rem 30px 0;
  }

  time {
    text-transform: uppercase;
    color: #000;
    font-size: 10px;
    margin-bottom: 0.5rem;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};
    line-height: 16px;
  }

  h3 {
    font-size: 16px;
    line-height: 30px;
    margin: 0 0 10px;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GEAwtarDWTCMedium,serif!important' : '')};
  }

  p {
    margin-bottom: 0;
    color: #898989;
  }
`;
